import React from "react";
import { ColorRing } from "react-loader-spinner";

const LoadingComponent = ({ loading }) => {
  return (
    loading && (
      <div
        className="absolute top-0 bg-[#00000013] left-0 rounded-md"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          zIndex:"9999"
        }}
      >
        <ColorRing
          height="80"
          width="80"
          ariaLabel="color-ring-loading"
          wrapperClass="color-ring-wrapper"
          colors={["#43996a", "#43996a", "#43996a", "#43996a", "#43996a"]}
        >
            Loading
        </ColorRing>
      </div>
    )
  );
};

export default LoadingComponent;
